import { ErrorResponse } from "@apollo/client/link/error";
import { print } from 'graphql';
import { getCId, getUId } from '@coverright/utils/CId';
import { getStoredUser } from '@coverright/utils/StoredUser';

export let graphqlErrorHandler: (errResponse: ErrorResponse) => void;

export const setErrorHandler = (callback: (errResponse: ErrorResponse) => void) => graphqlErrorHandler = callback;

const isBrowser = typeof window !== 'undefined';

export const errorTracker = (errResponse: ErrorResponse, token?: string) => {
  const errorObj: any = {
    graphQLErrors: errResponse.graphQLErrors,
    networkError: errResponse.networkError,
    cId: isBrowser ? getCId() : undefined,
    uId: isBrowser ? getUId() : undefined,
    request: {
      query: print(errResponse.operation.query),
      variables: errResponse.operation.variables
    },
    response: errResponse.response,
    env: isBrowser ? getStoredUser() : undefined,
    version: isBrowser ? (window as any).version : undefined,
    token
  }

  if (isBrowser && sessionStorage.getItem('filters')) {
    errorObj['maFilters'] = JSON.parse(sessionStorage.getItem('filters') as string);
  }

  if (isBrowser && sessionStorage.getItem('medigapFilters')) {
    errorObj['mgFilters'] = JSON.parse(sessionStorage.getItem('medigapFilters') as string);
  }

  if (isBrowser && (window as any).track) {
    (window as any)?.track('error', {
      message: 'request error',
      ...errorObj
    });
  }

  console.error(errorObj)
}
